import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthComponent } from '../login/auth.component';
import { LoginService } from '../login/login.service';
import { HomeService } from './home.service';

@Component({
  selector: 'app-home',
  template: '',
  providers: [ HomeService, LoginService ]
})
export class HomeComponent extends AuthComponent{
  constructor(
    router:Router, 
    loginService: LoginService,
    private homeService: HomeService
  ) {
    super(router, loginService);
    this.homeService.setHomeList().then(()=>{
      this.router.navigateByUrl('/products');
    }).catch((e)=>{
      this.router.navigateByUrl('/error/not-authorised');
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/home/home.component.ts